{
  "nav.startHere": "Mulai Di Sini",
  "nav.about": "Tentang",
  "nav.protocols": "Protokol",
  "nav.tools": "Alat",
  "nav.compliance": "Kepatuhan",
  "nav.personal": "Protokol Pribadi",
  "nav.organization": "Protokol Organisasi",
  "nav.mission": "Misi & Visi",
  "nav.scope": "Ruang Lingkup & Non-Jaminan",
  "nav.standards": "Pemetaan Standar",
  "nav.changelog": "Catatan Perubahan",
  "nav.governance": "Tata Kelola",
  "nav.disclaimer": "Penafian Hukum",
  "nav.contact": "Hubungi Kami",
  
  "hero.title1": "Amankan",
  "hero.title2": "Dunia Digital Anda",
  "hero.subtitle": "Platform protokol keamanan siber dan kesiapan global untuk individu dan organisasi. Berdasarkan praktik standar industri dan kerangka keamanan global.",
  "hero.cta.start": "Mulai Penilaian Keamanan",
  "hero.cta.learn": "Pelajari Lebih Lanjut",
  "hero.trust.standards": "Selaras dengan Standar",
  "hero.trust.standardsDesc": "Praktik terbaik global",
  "hero.trust.defensive": "Hanya Defensif",
  "hero.trust.defensiveDesc": "Panduan keamanan etis",
  "hero.trust.global": "Platform Global",
  "hero.trust.globalDesc": "Protokol internasional",
  
  "home.tab.personal": "Protokol Pribadi",
  "home.tab.organization": "Protokol Organisasi",
  "home.personal.title": "Mulai dengan 10 langkah ini",
  "home.personal.desc": "Kontrol keamanan esensial yang harus diterapkan setiap individu segera untuk mencegah 90% serangan umum.",
  "home.org.title": "Dasar Keamanan Organisasi",
  "home.org.desc": "Kontrol tata kelola dan teknis esensial yang harus ditetapkan setiap organisasi untuk mengurangi risiko siber dan meningkatkan ketahanan.",
  "home.org.note": "Langkah-langkah ini mewakili dasar minimum yang dapat diterapkan organisasi segera, terlepas dari ukuran atau industri.",
  "home.checklist.title": "10 Langkah Esensial",
  "home.principle1.title": "Pertahanan Berlapis",
  "home.principle1.titleOrg": "Keamanan Berlapis",
  "home.principle1.desc": "Terapkan beberapa kontrol keamanan independen sehingga kegagalan satu kontrol tidak membahayakan keamanan keseluruhan.",
  "home.principle1.descOrg": "Beberapa kontrol independen sehingga jika satu gagal, yang lain tetap efektif.",
  "home.principle2.title": "Pola Pikir Zero Trust",
  "home.principle2.titleOrg": "Verifikasi Berkelanjutan",
  "home.principle2.desc": "Jangan mengandalkan kepercayaan implisit. Verifikasi akses secara terus-menerus berdasarkan identitas, perangkat, dan konteks.",
  "home.principle2.descOrg": "Verifikasi setiap permintaan akses dan asumsikan potensi kompromi setiap saat.",
  "home.standards.badge": "Pendekatan Berbasis Standar",
  "home.standards.title": "Dibangun di atas Standar Keamanan Global",
  "home.standards.desc": "Protokol kami diselaraskan secara ketat dengan kerangka kerja keamanan siber dan praktik terbaik yang diakui secara internasional.",
  "home.standards.risk.title": "Manajemen Risiko",
  "home.standards.risk.desc": "Pendekatan berbasis risiko yang komprehensif untuk tata kelola keamanan siber dan ketahanan operasional.",
  "home.standards.risk.functions": "Kelola, Identifikasi, Lindungi, Deteksi, Tanggapi, Pulihkan",
  "home.standards.controls.title": "Kontrol Keamanan",
  "home.standards.controls.desc": "Standar internasional untuk Sistem Manajemen Keamanan Informasi dengan kontrol komprehensif.",
  "home.standards.controls.count": "114 kontrol keamanan di 14 domain",
  "home.standards.practices.title": "Praktik Terbaik",
  "home.standards.practices.desc": "Kontrol keamanan yang diprioritaskan dan dapat ditindaklanjuti untuk bertahan dari serangan siber paling umum.",
  "home.standards.practices.count": "18 kontrol keamanan kritis",
  "home.standards.cta": "Lihat Pemetaan Standar Lengkap",
  
  "start.badge": "Pilih Jalur Penilaian Anda",
  "start.title": "Penilaian Risiko Keamanan",
  "start.subtitle": "Pilih jenis penilaian Anda untuk menerima protokol keamanan siber yang disesuaikan, rencana tindakan prioritas, dan peta jalan mitigasi risiko.",
  "start.disclaimer": "Penilaian ini memberikan panduan praktis dan prioritas, bukan jaminan keamanan lengkap.",
  "start.personal.badge": "Pribadi",
  "start.personal.title": "Penilaian Risiko Keamanan Pribadi",
  "start.personal.desc": "Ikuti penilaian 3 menit ini untuk mengevaluasi risiko keamanan siber pribadi Anda berdasarkan akun, perangkat, dan kebiasaan digital harian Anda.",
  "start.personal.benefit1": "Protokol keamanan pribadi yang dipersonalisasi",
  "start.personal.benefit2": "Daftar periksa prioritas untuk perangkat dan akun Anda",
  "start.personal.benefit3": "Tindakan segera untuk mengurangi risiko siber umum",
  "start.personal.audience": "Dirancang untuk individu, profesional, dan pengguna sehari-hari.",
  "start.personal.cta": "Mulai Penilaian Pribadi",
  "start.org.badge": "Organisasi",
  "start.org.title": "Penilaian Risiko Keamanan Siber Organisasi",
  "start.org.desc": "Selesaikan penilaian 3 menit ini untuk mengevaluasi postur keamanan siber organisasi Anda di seluruh identitas, perangkat, perlindungan data, dan kesiapan insiden.",
  "start.org.benefit1": "Protokol keamanan organisasi yang disesuaikan",
  "start.org.benefit2": "Peta jalan peningkatan 30/60/90 hari yang diprioritaskan",
  "start.org.benefit3": "Kesenjangan kontrol kunci yang selaras dengan standar global",
  "start.org.audience": "Dirancang untuk perusahaan, LSM, sekolah, dan institusi dari semua ukuran.",
  "start.org.cta": "Mulai Penilaian Organisasi",
  "start.trust.time": "Penilaian 3 menit",
  "start.trust.standards": "Protokol selaras standar",
  "start.trust.results": "Hasil yang dapat ditindaklanjuti segera",
  "start.youWillReceive": "Anda akan menerima:",
  
  "personal.title": "Protokol Keamanan Pribadi",
  "personal.subtitle": "Strategi pertahanan komprehensif yang dibangun di atas 6 pilar inti. Terapkan kontrol ini untuk mengamankan kehidupan digital Anda dari ancaman modern.",
  
  "org.badge": "Protokol Keamanan Organisasi",
  "org.title": "Protokol Keamanan",
  "org.titleHighlight": "Organisasi",
  "org.subtitle": "Protokol keamanan terstruktur berbasis praktik terbaik untuk membantu organisasi mengurangi risiko siber, melindungi aset kritis, dan meningkatkan ketahanan.",
  "org.cta.start": "Mulai Protokol Keamanan",
  "org.cta.assessment": "Ikuti Penilaian Risiko",
  "org.why.title1": "Kontinuitas Bisnis",
  "org.why.desc1": "Pastikan organisasi Anda dapat bertahan dan pulih dari serangan siber tanpa downtime yang melumpuhkan.",
  "org.why.title2": "Kepatuhan Regulasi",
  "org.why.desc2": "Penuhi kewajiban berdasarkan undang-undang perlindungan data dan standar industri untuk menghindari denda dan masalah hukum.",
  "org.why.title3": "Kepercayaan Pelanggan",
  "org.why.desc3": "Tunjukkan komitmen terhadap keamanan untuk membangun kepercayaan dengan klien dan mitra.",
  "org.domains.title": "Domain Keamanan Inti",
  "org.domain.govern.title": "Tata Kelola & Kepemimpinan",
  "org.domain.govern.desc": "Tetapkan kepemilikan keamanan, kebijakan, dan struktur pengambilan keputusan untuk memandu program keamanan Anda.",
  "org.domain.identify.title": "Aset & Kesadaran Risiko",
  "org.domain.identify.desc": "Identifikasi dan pahami aset kritis, data, dan risiko Anda untuk memprioritaskan upaya perlindungan.",
  "org.domain.protect.title": "Perlindungan & Pencegahan",
  "org.domain.protect.desc": "Terapkan perlindungan seperti kontrol akses, keamanan endpoint, dan backup untuk mengurangi risiko.",
  "org.domain.detect.title": "Deteksi & Pemantauan",
  "org.domain.detect.desc": "Siapkan logging dan pemantauan untuk mendeteksi aktivitas mencurigakan dan insiden keamanan lebih awal.",
  "org.domain.respond.title": "Respons Insiden",
  "org.domain.respond.desc": "Bersiaplah untuk merespons secara efektif ketika insiden keamanan terjadi dengan prosedur dan peran yang jelas.",
  "org.domain.recover.title": "Pemulihan & Peningkatan",
  "org.domain.recover.desc": "Rencanakan pemulihan dari insiden dan terus tingkatkan postur keamanan Anda.",
  "org.domain.viewProtocol": "Lihat Protokol",
  "org.roadmap.title": "Peta Jalan Implementasi",
  "org.roadmap.subtitle": "Pendekatan praktis 90 hari untuk membangun keamanan organisasi. Mulai dengan dasar berdampak tinggi dan secara progresif perkuat pertahanan Anda.",
  "org.roadmap.phase1.title": "30 Hari Pertama: Fondasi",
  "org.roadmap.phase1.item1": "Tunjuk pemilik keamanan dan definisikan peran",
  "org.roadmap.phase1.item2": "Aktifkan MFA untuk semua akun kritis",
  "org.roadmap.phase1.item3": "Terapkan strategi backup 3-2-1",
  "org.roadmap.phase1.item4": "Tetapkan kebijakan keamanan dasar",
  "org.roadmap.phase1.item5": "Buat inventaris aset",
  "org.roadmap.phase2.title": "Hari 31-60: Visibilitas & Perlindungan",
  "org.roadmap.phase2.item1": "Deploy perlindungan endpoint di semua perangkat",
  "org.roadmap.phase2.item2": "Aktifkan logging pada sistem kritis",
  "org.roadmap.phase2.item3": "Lakukan pelatihan kesadaran keamanan",
  "org.roadmap.phase2.item4": "Tinjau dan dokumentasikan akses vendor",
  "org.roadmap.phase2.item5": "Terapkan proses manajemen patch",
  "org.roadmap.phase3.title": "Hari 61-90: Respons & Ketahanan",
  "org.roadmap.phase3.item1": "Buat rencana respons insiden",
  "org.roadmap.phase3.item2": "Lakukan latihan tabletop",
  "org.roadmap.phase3.item3": "Uji pemulihan backup",
  "org.roadmap.phase3.item4": "Lakukan tinjauan akses triwulanan",
  "org.roadmap.phase3.item5": "Dokumentasikan pelajaran dan peningkatan",
  
  "risk.breadcrumb": "Penilaian Risiko",
  "risk.personal.badge": "Penilaian Pribadi",
  "risk.personal.title": "Penilaian Risiko Keamanan Pribadi",
  "risk.personal.desc": "Evaluasi risiko keamanan siber pribadi Anda berdasarkan akun, perangkat, dan kebiasaan digital harian Anda. Terima protokol keamanan yang dipersonalisasi dan daftar tindakan prioritas.",
  "risk.org.badge": "Penilaian Organisasi",
  "risk.org.title": "Penilaian Risiko Keamanan Siber Organisasi",
  "risk.org.desc": "Evaluasi postur keamanan siber organisasi Anda di seluruh identitas, perangkat, perlindungan data, dan kesiapan insiden. Terima protokol yang disesuaikan dan peta jalan peningkatan 30/60/90 hari.",
  "risk.disclaimer": "Penilaian ini memberikan panduan praktis dan prioritas, bukan jaminan keamanan lengkap.",
  
  "tools.title": "Perpustakaan Alat",
  "tools.subtitle": "Daftar kurasi alat resmi dan terpercaya untuk memeriksa eksposur Anda dan mengamankan akun Anda.",
  "tools.warning.title": "Peringatan:",
  "tools.warning.desc": "Jangan pernah menggunakan database pelanggaran tidak resmi atau mengunduh data yang bocor. Alat yang tercantum di bawah ini legal, aman, dan menggunakan metode yang menjaga privasi (seperti k-anonymity) untuk memeriksa status Anda.",
  
  "footer.brand.desc": "Platform protokol keamanan siber dan kesiapan global untuk individu dan organisasi.",
  "footer.brand.note": "Panduan keamanan defensif yang selaras dengan standar.",
  "footer.protocols": "Protokol",
  "footer.resources": "Sumber Daya",
  "footer.about": "Tentang",
  "footer.riskAssessment": "Penilaian Risiko",
  "footer.toolsLibrary": "Perpustakaan Alat",
  "footer.complianceGuides": "Panduan Kepatuhan",
  "footer.standardsMapping": "Pemetaan Standar",
  "footer.missionVision": "Misi & Visi",
  "footer.scopeDisclaimer": "Ruang Lingkup & Penafian",
  "footer.contact": "Kontak",
  "footer.copyright": "CyberSecurityProtocol. Hak cipta dilindungi.",
  "footer.educational": "Panduan keamanan siber edukatif dan defensif saja.",
  "footer.legal": "Hukum",
  "footer.nonGuarantee": "Non-Jaminan",
  "footer.builtBy": "Dibangun oleh UXER — Bagian dari Asosiasi Teknologi Informasi dan Open Source (ATIOS)",
  
  "common.loading": "Memuat...",
  "common.error": "Kesalahan",
  "common.success": "Berhasil",
  "common.cancel": "Batal",
  "common.save": "Simpan",
  "common.continue": "Lanjutkan",
  "common.back": "Kembali",
  "common.next": "Selanjutnya",
  "common.finish": "Selesai",
  "common.viewMore": "Lihat Lebih Banyak",
  "common.learnMore": "Pelajari Lebih Lanjut",
  "common.getStarted": "Mulai"
}